import { getConfig } from '../utils/get-config';
import { CONFIG_CODES } from '../types';
import type { Configuration } from '@azure/msal-browser';

// eslint-disable-next-line spellcheck/spell-checker
export const scopes: string[] = ['api://0cfa4bcc-9420-4d66-a767-58523179bb9d/User.Read'];

export const msalConfig: Configuration = {
  auth: {
    clientId: getConfig(CONFIG_CODES.REACT_APP_AUTH_CLIENT_ID),
    redirectUri: getConfig(CONFIG_CODES.REACT_APP_AUTH_REDIRECT_URI),
    authority: getConfig(CONFIG_CODES.REACT_APP_AUTH_AUTHORITY),
  },
  cache: {
    cacheLocation: 'sessionStorage',
  },
};
